import "./ViewIssuer.scss";
import {
  IonAvatar,
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardContent,
  IonText,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { starOutline, chevronBack } from "ionicons/icons";
import qr from "qr-image";
import cardAvatar from "../../assets/images/avatar-card.png";
import { createRequestHistory } from "../../api/requestHistory";

interface Props {
  data: any;
  user: any;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  updateIssuer: (
    payload: any,
    autoClose?: boolean,
    isDeactivate?: boolean
  ) => void;
}

// const customAlertOptions = {
//   header: 'Issuer Type',
// };

const getImageDataURI = (data: any) => {
  let pngBuffer = qr.imageSync(data, { type: "png" });
  return "data:image/png;charset=utf-8;base64, " + pngBuffer.toString("base64");
};

const ViewIssuer: React.FC<Props> = ({
  data,
  user,
  isOpen,
  setIsOpen,
  updateIssuer,
}) => {
  const [qrCode, setQrCode] = useState<any>(null);
  const [readOnly, setReadOnly] = useState<boolean>(true);
  const [issuer, setIssuer] = useState<any>({
    id: "",
    url: "",
    name: "",
    type: "",
    appId: "",
    color: "",
    identity: "",
    background: "",
  });

  const [isFlip, setIsFlip] = useState<boolean>(false);

  useEffect(() => {
    if (data) {
      setIssuer((prev: any) => ({
        ...prev,
        ...data,
      }));

      if (data.identity) {
        let tempQrCode: any = getImageDataURI(data.identity || "anonymous");
        setQrCode(tempQrCode);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const onCloseModal = () => {
    setIsOpen(false);
    setReadOnly(true);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setIssuer((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getName = (appId: number) => {
    let name: any;
    switch (appId) {
      case 1: {
        name = "Verifier";
        break;
      }
      case 2: {
        name = "Abaxx Messenger";
        break;
      }
      case 3: {
        name = "Abaxx Exchange";
        break;
      }
      case 4: {
        name = "Sign abaxx";
        break;
      }
      case 5: {
        name = "Clearing";
        break;
      }
      default: {
        name = "Verifier";
        break;
      }
    }

    return name;
  };

  const handleSave = async() => {
    updateIssuer(issuer);
    await createRequestHistory({
      user,
      appId: issuer.appId,
      alias: user.email,
      type: "update_issuer",
      status: "UPDATED",
      name: getName(issuer.appId)
     });
     setReadOnly(true);
  };

  const handleDeactivate = async () => {
    updateIssuer({ ...issuer, ...{ active: false } }, true, true);
    await createRequestHistory({
      user,
      appId: issuer.appId,
      alias: user.email,
      type: "deactivate_issuer",
      status: "DEACTIVATED",
      name: getName(issuer.appId)
     });
  };

  return (
    <>
      <IonModal
        isOpen={isOpen}
        onDidDismiss={onCloseModal}
        className="view-issuer-modal"
        backdropDismiss={true}
      >
        <IonHeader mode="ios">
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton
                className="back-btn"
                onClick={() => {
                  readOnly ? onCloseModal() : setReadOnly(true);
                }}
              >
                <IonIcon icon={chevronBack} />
              </IonButton>
            </IonButtons>
            <IonTitle>
              {readOnly && "View Credential"}
              {!readOnly && "Edit Credential"}
            </IonTitle>

            {readOnly && (
              <IonButtons slot="end">
                <IonButton
                  className="edit-btn"
                  onClick={() => setReadOnly(false)}
                >
                  Edit
                </IonButton>
              </IonButtons>
            )}
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <div className="view-issuer-container">
            <div className="issuer-card">
              <div
                className={`flip-card ${isFlip ? "back-flip" : "front-flip"}`}
              >
                <div
                  className="flip-card-inner"
                  onClick={() => {
                    setIsFlip(!isFlip);
                  }}
                >
                  <IonCard
                    className="issuer-item flip-card-front"
                    style={{
                      background: issuer.background,
                      color: issuer.color,
                    }}
                  >
                    <IonCardContent>
                      <div className="content-container-qr">
                        <div className="qr-container">
                          <img
                            src={qrCode}
                            className="qr-code"
                            width="100"
                            alt="qr"
                          />
                        </div>
                      </div>
                    </IonCardContent>
                  </IonCard>
                  <IonCard
                    className="issuer-item flip-card-back"
                    style={{
                      background: issuer.background,
                      color: issuer.color,
                    }}
                  >
                    <IonCardContent>
                      <div className="content-container">
                        <div className="top-section">
                          <div className="issuer-avatar">
                            <IonAvatar>
                              <img
                                src={cardAvatar}
                                alt="avatar"
                                style={{ width: "34px", height: "34px" }}
                              />
                            </IonAvatar>
                          </div>

                          <div className="issuer-type">
                            <IonText>{issuer.name}</IonText>
                          </div>
                        </div>

                        <div className="bottom-section">
                          {issuer.type === "identity" ? (
                            <React.Fragment>
                              <IonText>Identity</IonText>
                              <IonIcon icon={starOutline} />
                            </React.Fragment>
                          ) : (
                            <IonText>Verified Credentials</IonText>
                          )}
                        </div>
                      </div>
                    </IonCardContent>
                  </IonCard>
                </div>
              </div>
            </div>
            {!readOnly && (
              <div className="btn-deactivate-container">
                <IonButton
                  mode="ios"
                  className="btn-deactivate"
                  expand="block"
                  fill="outline"
                  onClick={() => {
                    handleDeactivate();
                  }}
                >
                  Deactivate
                </IonButton>
              </div>
            )}
            <IonList lines="none" mode="ios">
              <IonItem className="input-item-list" detail={false}>
                <IonLabel
                  position="stacked"
                  style={readOnly ? { color: "#9CA3AF" } : { color: "#fff" }}
                >
                  Issuer Name
                </IonLabel>
                <IonInput
                  name="name"
                  type="text"
                  onIonChange={handleChange}
                  value={issuer.name}
                  style={readOnly ? {} : { color: "#fff" }}
                  readonly={readOnly}
                  disabled={readOnly}
                  maxlength={48}
                />
              </IonItem>

              <IonItem className="input-item-list" detail={false}>
                <IonLabel position="stacked" style={{ color: "#9CA3AF" }}>
                  Type
                </IonLabel>
                {readOnly ? (
                  <IonInput
                    type="text"
                    value={
                      issuer.type === "identity"
                        ? "Identity"
                        : "Verified Credentials"
                    }
                    readonly={true}
                    disabled={true}
                  />
                ) : (
                  <IonInput
                    type="text"
                    value={
                      issuer.type === "identity"
                        ? "Identity"
                        : "Verified Credentials"
                    }
                    readonly={true}
                    disabled={true}
                  />
                  // <IonSelect
                  //   interface="alert"
                  //   interfaceOptions={customAlertOptions}
                  //   value={issuer.type}
                  //   onIonChange={e => setIssuer((prev: any) => ({ ...prev, type: e.detail.value }))}>
                  //   <IonSelectOption value="identity">Identity</IonSelectOption>
                  //   <IonSelectOption value="verifiedCredentials">Verified Credentials</IonSelectOption>
                  // </IonSelect>
                )}
              </IonItem>

              <IonItem className="input-item-list" detail={false}>
                <IonLabel position="stacked" style={{ color: "#9CA3AF" }}>
                  URL
                </IonLabel>
                <IonInput
                  name="url"
                  type="url"
                  onIonChange={handleChange}
                  value={issuer.url}
                  readonly={true}
                  disabled={true}
                />
              </IonItem>

              <IonItem className="input-item-list" detail={false}>
                <IonLabel position="stacked" style={{ color: "#9CA3AF" }}>
                  Identity
                </IonLabel>
                <IonInput
                  name="identity"
                  type="text"
                  onIonChange={handleChange}
                  value={issuer.identity}
                  readonly={true}
                  disabled={true}
                />
              </IonItem>
            </IonList>
          </div>
        </IonContent>
        {readOnly ? null : (
          <IonFooter>
            <IonToolbar>
                  <IonButton
                    mode="ios"
                    expand="block"
                    fill="solid"
                    color="danger"
                    disabled={issuer.name === data.name}
                    onClick={handleSave}
                  >
                    Save
                  </IonButton>
            </IonToolbar>
          </IonFooter>
        )}
      </IonModal>
    </>
  );
};

export default ViewIssuer;
